(function () {
    angular.module('ngmvac')
        .controller('FacturacionController', FacturacionController);

    FacturacionController.$inject = ['$scope','$window','FacturacionFactory'];

    function FacturacionController($scope,$window,FacturacionFactory) {
        var vm = this;
        vm.mensaje = false;
        vm.Countries = [];
        vm.States = [];
        vm.selectedCountry="México";
        // vm.selectedState="";
        vm.Municipalitys=[];        
        
        vm.params_factura_save;
        vm.crfc="";
        // ESTRELLAS
        vm.cincoLux     = '5LUX';
        vm.cincoEst     = '5EST';
        vm.cuatroLux    = '4LUX';
        vm.cuatroEst    = '4EST';
        vm.h3_5         = 'H3_5';
        vm.tresEst      = '3EST';
        vm.h2_5         = 'H2_5';
        vm.dosEst       = '2EST';
        vm.h1_5         = 'H1_5';
        vm.unoEst       = '1EST';



        
        vm.ingresar = function () {
            clave = $(".input-clave").val();
            correo = $(".input-correo").val();
           $validarc = validarEmail(correo);
            if (clave == "") {
                swal({
                    title: "Debes ingresar clave de reservacion.",
                    imageUrl: "img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });
            } else if (correo == "") {
                swal({
                    title: "Debes ingresar un correo.",
                    imageUrl: "img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });

            }else if ($validarc == "error") {
            swal({
                title: "Debes ingresar un correo Valido.",
                imageUrl: "img/signoadmiracion.png",
                showConfirmButton: true,
                allowEscapeKey: false
            });
        } else {
            vm.mensaje=false;
              var  params_factura = {
                  
                        'clave' : clave,
                        'correo'  : correo
                  
                };
                  FacturacionFactory.envio(params_factura).then(function(response){
                      
                  estado=response.data.estado;
                  st=response.data.status;
                
                     if(estado == true){
                         if(st == "nvo"){
                            
                            vm.has=response.data.has; 
                            vm.params_factura_save = params_factura;                        
                            $window.location.href='/Facturacion/verReserva/'+vm.has;
                            
                         }else{
                           
                              vm.has=response.data.has;
                              $window.location.href='/Facturacion/exito/'+vm.has;
                         }
                         
                    }else{
                        vm.stAlert="block"
                        vm.clave ="";
                        vm.correo=""
                        vm.mensaje = true;
                         swal({
                            title: response.data.mensaje,
                            imageUrl: "/img/error.png",
                            showConfirmButton: true,
                            allowEscapeKey: false
                        });
                        // vm.alertmensaje = response.data.mensaje;                    

                    }
                });
            }
        }

        function validarEmail(valor) {
            if (/^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i.test(valor)) {
                return "correcto";
            } else {
                return "error";
            }
        }

        ///INGRESAR LOS DATOS DEL CLIENTE
        
        vm.onSelect = function (sub) {
            if(sub != ""){
                FacturacionFactory.selectRFC(sub).then(function(response){
                    vm.calle_s=response.data[0].calle;
                    vm.razon_s=response.data[0].razon_social;
                    vm.numExt=response.data[0].nexterior;
                    vm.numInt=response.data[0].ninterior;
                    vm.colo=response.data[0].colonia;
                    vm.selectedCountry=response.data[0].pais;                       
                    vm.codigopostal=response.data[0].codigopostal;
                    vm.crfc = sub;
                
                });
            }else{
                vm.calle_s="";
                vm.razon_s="";
                vm.numExt="";
                vm.numInt="";
                vm.colo="";
                vm.selectedCountry="México";
                vm.codigopostal="";
                vm.crfc = "";
            }
            
            
        }

        FacturacionFactory.country().then(function(response){
           vm.Countries=response.data;           
        });

        FacturacionFactory.state().then(function(response){
             vm.States=response.data.datos;
        
        });

        FacturacionFactory.municipality().then(function(response){
            vm.Municipalitys=response.data;
            
        });



        vm.validar = function(){
                              
            has = $('.tabla').val();
            referencia_id = $('.referencia').val();

            rfc = $(".txtRfc").val();
            razon = $(".txtRazon").val();
            calle = $(".txtCalle").val();
            exterior = $(".txtNexterior").val();
            interior = $(".txtNinterior").val();
            colonia = $(".txtColonia").val();
            pais = $(".txtPais").val();
            estado = $(".txtEstado").val();
            municipio = $(".txtMunicipio").val();
            cp = $(".txtCp").val();
            facturacorreo = $(".txtCorreo").val(); 

           $razon_social = validar_razon_social(razon);  
           $rfc_valido   = validar_RFC(rfc);
            $correoFactura = validarEmail(facturacorreo);
            $cp_valido = validar_C_P(cp);
            
            if (rfc == "") {
                swal({
                    title: "Debes ingresar RFC",
                    imageUrl: "/img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });
            }else if ($rfc_valido == "noValido") {
                swal({
                    title: "Ingrese un RFC correcto",
                    imageUrl: "/img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });

            } else if (razon == "") {
                swal({
                    title: "Debes ingresar Nombre o Razon Social",
                    imageUrl: "/img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });

            }else if ($razon_social != "") {
                swal({
                    title: "Su razón social tiene caracteres especiales ("+$razon_social+"). Para facturar comuniquese al tel.\n 01(998)-8862496. (Ext. 100).",
                    imageUrl: "/img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });

            }else if (calle == "") {
                swal({
                    title: "Debes ingresar Calle",
                    imageUrl: "/img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });

            }else if (colonia == "") {
                swal({
                    title: "Debes ingresar Colonia",
                    imageUrl: "/img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });

            }else if (pais == "") {
                swal({
                    title: "Debes ingresar Pais",
                    imageUrl: "/img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });

            }else if (estado == "") {
                swal({
                    title: "Debes ingresar Estado.",
                    imageUrl: "/img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });

            }else if (municipio == "") {
                swal({
                    title: "Debes ingresar Municipio.",
                    imageUrl: "/img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });

            } else if (cp == "") {
                swal({
                    title: "Debes ingresar Codigo Postal.",
                    imageUrl: "/img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });

            }else if ($cp_valido == "error") {
                swal({
                    title: "Debes ingresar Codigo Postal Valido.",
                    imageUrl: "/img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });

            }else if (facturacorreo == "") {
                swal({
                    title: "Debes ingresar un correo.",
                    imageUrl: "/img/signoadmiracion.png",
                    showConfirmButton: true,
                    allowEscapeKey: false
                });

            } else if ($correoFactura == "error") {
            swal({
                title: "Debes ingresar un correo Valido.",
                imageUrl: "/img/signoadmiracion.png",
                showConfirmButton: true,
                allowEscapeKey: false
            });
        } else {

            if(vm.selectedCountry != 'México'){
                vm.selectedState ="-";
                vm.municipio="-";
            }
           
            var params = {
                    params :{
                      
                        razon_social   : razon,
                        valor_rfc      : rfc,
                        dato_calle     : calle,
                        num_interior   : interior,
                        num_exterio    : exterior,
                        dato_colonia   : colonia,
                        dato_pais      : vm.selectedCountry,
                        dato_estado    : vm.selectedState,
                        dato_municipio : vm.municipio,
                        codigo_postal  : cp,
                        cliente_reservaciones : has,
                        referecia      : referencia_id

                    }
            }
            
                swal({   title: "¿Esta seguro de continuar?",  
                text: "Enviar informacion.",    
                type: "info",   
                showCancelButton: true,   
                closeOnConfirm: false,  
                 showLoaderOnConfirm: true, }, 
                 function(){                     
                      setTimeout(function(){}, 2000);
                      FacturacionFactory.insertar(params).then(function(response){
                         console.log(response, 'fin_datos');
                         if(response.data.error ==  false){
                             swal({ 
                                  title: "¡Datos enviados!",
                                  type: "success",
                                  text:"Recibira su factura en un periodo menor a 48 hrs. \n ¿Dudas? Comuniquese al tel.\n 01(998)-8862496. (Ext. 100).",
                                    allowEscapeKey: false 
                                  },
                                  function()
                                  {
                                     $window.location.href='/Facturacion/exito/'+response.data.has;
                                });
                         }
                     });
                            
                        }
                );
            
        

        
        }
    }
    
        function validar_razon_social(valor){
          charerror="";
          charespecial =["$","#","&","/","-","!","¡","|","°","¬","%","(",")","=","?",
                "'","¿","¡","¨","+","*","~","{",
                "}","[","]","^","`","@"];
         
            for(i=0; i<=charespecial.length; i++)
                  {
                   $resul=valor.indexOf(charespecial[i]);

                   if($resul!='-1')
                   {
                    charerror=charespecial[i];
                    break;
                   }
                  }
            return charerror;

        }

        function validar_RFC(value){
            expre_rfc= /^([A-Z,Ñ,&]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[A-Z|\d]{3})$/
            $val = value.match(expre_rfc);
            if($val == null){
                return "noValido";
            }else{
                return "Valido";
            }
        }

        function validar_C_P(value){
            
            if(value.length != 5){
                return "error";
            }else{
                return "valido"
            }
        }

        
             

       
    }
})();